export default "__VITE_ASSET__BQKo8Sh0__"